// utils/auth.js
export function isUserLoggedIn() {
    // If token exists, consider user as logged in
    // (In real apps, you might want to also validate the token or check expiration)
    return !!localStorage.getItem("token");
  }
  